import { Grid } from '@mui/material';

import { ScoreType } from '@/domain/impact/impact.entity';
import {
  scrollQuizPanelToId,
  scrollQuizPanelToTop,
} from '@/ui/components/quiz-panel/QuizPanel.utils';
import { TopicScoreAndDetailsCard } from '@/ui/pages/app/components/topic-score-card/TopicScoreAndDetailsCard';
import { TopicScoreDetailsData } from '@/ui/pages/app/components/topic-score-card/type';

export function SectorMainContent({
  allData,
  setSelectedScoreType,
  setSelectedDetailsValueId,
}: {
  allData: {
    co2: TopicScoreDetailsData;
    env: TopicScoreDetailsData;
    ess: TopicScoreDetailsData;
  };
  setSelectedScoreType: React.Dispatch<React.SetStateAction<ScoreType>>;
  setSelectedDetailsValueId: (valueId: string) => void;
}) {
  const onClickDetailsItem = (type: ScoreType, id: string) => {
    setSelectedScoreType(type); // this will change the scoretype in quiz-panel
    setSelectedDetailsValueId(id); // this will change the topics in quiz-panel (ess-env)
    if (type === 'co2') {
      scrollQuizPanelToId(`#${id}-form`); // for co2 all questions are in one view, so we scroll to category
    } else {
      scrollQuizPanelToTop();
    }
  };

  const onClickAnswerAll = (type: ScoreType) => {
    setSelectedScoreType(type);
    setSelectedDetailsValueId('');
    scrollQuizPanelToTop();
  };

  return (
    <Grid container spacing={3}>
      <Grid item xs={12} lg={4}>
        <TopicScoreAndDetailsCard
          type={'co2'}
          data={allData.co2}
          onClickDetailsItem={onClickDetailsItem}
          onClickAnswerAll={onClickAnswerAll}
        />
      </Grid>
      <Grid item xs={12} lg={4}>
        <TopicScoreAndDetailsCard
          type={'env'}
          data={allData.env}
          onClickDetailsItem={onClickDetailsItem}
          onClickAnswerAll={onClickAnswerAll}
          showAnswerAll={false}
        />
      </Grid>
      <Grid item xs={12} lg={4}>
        <TopicScoreAndDetailsCard
          type={'ess'}
          data={allData.ess}
          onClickDetailsItem={onClickDetailsItem}
          onClickAnswerAll={onClickAnswerAll}
          showAnswerAll={false}
        />
      </Grid>
    </Grid>
  );
}
